import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { buyOrbitAIAddon as buyOrbitAIAddonAPI, v2UserDetails } from 'src/common/Scraper';
import { stateUserDetails } from 'src/redux/counterSlice';
import { BuyAddonPayload, BuyAddonResponse } from '../types/addon.type';

/**
 * React Query mutation hook to purchase the Orbit AI Addon.
 */
export const useBuyOrbitAIAddon = (): UseMutationResult<
  BuyAddonResponse,
  Error,
  BuyAddonPayload
> => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation<BuyAddonResponse, Error, BuyAddonPayload>({
    mutationKey: ['buyOrbitAIAddon'],
    mutationFn: (payload: BuyAddonPayload) => buyOrbitAIAddonAPI(payload),
    onSuccess: async () => {
      // Refetch and dispatch updated user details to Redux to trigger dynamic UI update
      try {
        const details = await v2UserDetails();
        if (details) {
          dispatch(stateUserDetails(details));
          // Update react-query cache directly to prevent stale cache from overwriting Redux state
          queryClient.setQueryData(['userDetails'], details);
        }
      } catch (err) {
        console.error("Failed to refetch user details on mutation success", err);
      }

      // Invalidate react-query cache
      queryClient.invalidateQueries({
        queryKey: ['userDetails'],
      });
    },
  });
};

export default useBuyOrbitAIAddon;
